import { render, staticRenderFns } from "./CardProduct.vue?vue&type=template&id=5826507f&"
import script from "./CardProduct.vue?vue&type=script&lang=js&"
export * from "./CardProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports